export default __webpack_public_path__ + "static/online-gorusme-programlari-e355369d5e96e99b1b4e07f02a3564f5.png";